import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../app/hooks';
import { performUserLogout } from '../../features/userLogin/userLoginSlice';
import { setCartItemsCount } from '../../features/cart/cartSlice';

export const UserLogout = () => {

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
      dispatch(performUserLogout(true))
      dispatch(setCartItemsCount(0));
      navigate("/login");
  }, [dispatch, navigate]);


  return (<></>)
}
